import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Tag } from 'src/app/model/tag';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {TagProvider} from '../../../providers';

@Component({
  selector: 'app-create-new-tag',
  templateUrl: './create-new-tag.component.html',
  styleUrls: ['./create-new-tag.component.scss']
})

export class CreateNewTagModal implements OnInit {
  subject: Subject<Tag>;
  subscription: any;
  isEdit = false;
  tag: Tag = new Tag();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private tagProvider: TagProvider
  ) { }

  ngOnInit(): void {
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc')
        this.onCancel();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  onConfirm(tag: Tag): void {
    this.bsModalRef.hide();
    this.subject.next(tag);
    this.subject.complete();
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }

  onSubmit(): void {
    this.tagProvider.saveTag(this.tag)
      .subscribe(data => {
        if (data.success) {
          this.onConfirm(Tag.parse(data.result));
        }
      });
  }

  setFavorite(): void {
    this.tag.QUICK_ACCESS = !this.tag.QUICK_ACCESS;
  }

}
